export const colors = [
  "#2E51A9", // blue
  "#ED6C02", // orange
  "#21AF48", // green
  "#8E24AA", // purple

  "#D32F2F", // red
  "#00897B", // teal
  "#F9A825", // amber
  "#5E35B1", // deep purple
  "#039BE5", // light blue
  "#7CB342", // lime green

  "#C2185B", // pink
  "#6D4C41", // brown
  "#3949AB", // indigo
  "#00ACC1", // cyan
  "#F4511E", // deep orange

  "#9CCC65", // soft green
  "#FB8C00", // orange 2
  "#1E88E5", // blue 2
  "#43A047", // green 2
  "#AB47BC", // purple 2
];

export const getAnomalyColor = (anomaly: string | string[]) => {
  if (anomaly?.includes("precipitation")) {
    return colors[0];
  } else if (anomaly?.includes("soil-moisture")) {
    return colors[1];
  } else if (anomaly?.includes("vegetation")) {
    return colors[2];
  } else if (anomaly?.includes("hybrid")) {
    return colors[3];
  } else {
    return "#000";
  }
};
